import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAnnouncements,
  createAnnouncement,
  updateAnnouncement,
  deleteAnnouncement,
} from "../src/slices/AnnouncementSlice";

function Announcement() {
  const dispatch = useDispatch();
  const { announcements, loading, error } = useSelector(
    (state) => state.announcements
  );

  const [newAnnouncement, setNewAnnouncement] = useState("");
  const [editing, setEditing] = useState(null);
  const [editText, setEditText] = useState("");

  const businessId = "6709f0331882028713f23319";

  useEffect(() => {
    dispatch(fetchAnnouncements(businessId));
  }, [dispatch, businessId]);

  const handleInputChange = (e) => {
    setNewAnnouncement(e.target.value);
  };

  const handleSaveAnnouncement = () => {
    if (!newAnnouncement.trim()) return;

    dispatch(
      createAnnouncement({
        title: "Announcement",
        description: newAnnouncement,
        businessId,
      })
    ).then(() => {
      setNewAnnouncement("");
      dispatch(fetchAnnouncements(businessId));
    });
  };

  const handleDeleteClick = (announcementId) => {
    if (window.confirm("Are you sure you want to delete this announcement?")) {
      dispatch(deleteAnnouncement({ announcementId, businessId })).then(() => {
        dispatch(fetchAnnouncements(businessId));
      });
    }
  };

  const handleEditClick = (announcement) => {
    setEditing(announcement);
    setEditText(announcement.description);
  };

  const handleUpdateSave = () => {
    dispatch(
      updateAnnouncement({
        announcementId: editing._id,
        title: editing.title,
        description: editText,
      })
    ).then(() => {
      setEditing(null);
      setEditText("");
      dispatch(fetchAnnouncements(businessId));
    });
  };

  return (
    <div className="announcement-section">
      <div className="announcement-preview">
        <h2>Current Announcements</h2>
        {loading ? (
          <p>Loading...</p>
        ) : error ? (
          <p style={{ color: "red" }}>Error: {error}</p>
        ) : announcements.length ? (
          <ul>
            {announcements.map((announcement) => (
              <li key={announcement._id}>
                <strong>{announcement.title}:</strong> {announcement.description}
                <div style={{ marginTop: '4px' }}>
                  <button
                    className="announcement-button"
                    onClick={() => handleEditClick(announcement)}
                  >
                    Edit
                  </button>
                  <button
                    className="announcement-button delete-button"
                    onClick={() => handleDeleteClick(announcement._id)}
                  >
                    Delete
                  </button>
                </div>
              </li>
            ))}
          </ul>
        ) : (
          <p>No announcements yet.</p>
        )}
      </div>

      <div className="announcement-edit" style={{ marginTop: "2rem" }}>
        <h3>Create New Announcement</h3>
        <textarea
          className="announcement-field"
          value={newAnnouncement}
          onChange={handleInputChange}
          placeholder="Type new announcement here"
        />
        <br />
        <button className="announcement-save" onClick={handleSaveAnnouncement} disabled={loading}>
          {loading ? "Saving..." : "Save Announcement"}
        </button>
      </div>

      {editing && (
        <div className="edit-popup" style={{ marginTop: "2rem", border: "1px solid #ccc", padding: "1rem" }}>
          <h3>Edit Announcement</h3>
          <textarea
            value={editText}
            onChange={(e) => setEditText(e.target.value)}
          />
          <br />
          <button onClick={handleUpdateSave}>Update</button>
          <button onClick={() => setEditing(null)} style={{ marginLeft: "8px" }}>
            Cancel
          </button>
        </div>
      )}
    </div>
  );
}

export default Announcement;
